import React from 'react';
import { ListItem } from 'material-ui/List';
import SidebarLink from '../../components/SidebarLink';
import style from './style.js';

const SidebarItemFacility = ({ edit, facility, matchPath }) => {
  const rootPath = edit ? 'facilities' : 'map';
  const selected = matchPath === `/${rootPath}/:facilityId/`;
  return (
    <ListItem
      // style={style.listItem}
      containerElement={<SidebarLink to={`/${rootPath}/${facility._id}/`} />}
      style={selected ? style.activeBuilding : {}}
      disabled={selected}
    >
      {facility.name}
    </ListItem>
  );
};

export default SidebarItemFacility;



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMap/SidebarItemFacility/index.js